import { getDefaultMix, GetAllBones } from "@project-rouge/rg-core";
import { addItemsToMuscle } from "./index3.js";
import { getCapturedDistances } from "./index234.js";
import { AggUnitsOnMuscleNMCS } from "./index235.js";
import { getFirstDoorDistances } from "./index236.js";
const AggBuildingFromAnatomyNmcs = ({ building, aggZoneProps, dataset, weights }) => {
  const distribution = aggZoneProps.unitMix || getDefaultMix(dataset);
  const bones = GetAllBones(building.data.anatomy);
  for (const bone of bones) {
    const muscles = bone.muscles.slice().sort((a, b) => (a.skipCores ? 0 : 1) - (b.skipCores ? 0 : 1));
    for (const muscle of muscles) {
      const endClosingDistances = getCapturedDistances(muscle);
      const endEntranceDistances = getFirstDoorDistances(muscle);
      const { flatsAndCores, onGFChildren } = AggUnitsOnMuscleNMCS({ dataset, muscle, distribution, weights, endClosingDistances, endEntranceDistances });
      addItemsToMuscle(building, muscle, flatsAndCores, onGFChildren);
    }
  }
  return { building };
};
export {
  AggBuildingFromAnatomyNmcs
};
//# sourceMappingURL=index188.js.map
